import { render, staticRenderFns } from "./dashboardPosts.vue?vue&type=template&id=3fe0d78a&lang=pug&"
import script from "./dashboardPosts.vue?vue&type=script&setup=true&lang=js&"
export * from "./dashboardPosts.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports